export const catalogConfig = {
  cnpj: 54517628000198,
  uf: 'RJ',
  cnae: 4729602,
};
